<nz-spin [nzSpinning]="isLoading">
    <!-- Feature Header Card -->
    <div class="mb-6 p-5 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 shadow-sm">
        <div class="flex items-start justify-between">
            <div class="flex-1">
                <h4 class="font-semibold text-gray-900 mb-2 text-lg">
                    <i nz-icon nzType="setting" nzTheme="outline" class="mr-2 text-blue-600"></i>
                    {{ feature?.name }}
                </h4>
                <p class="text-gray-600 text-sm leading-relaxed">{{ feature?.description }}</p>
            </div>
            <nz-tag *ngIf="feature?.id || feature?.feature_id" [nzColor]="'blue'" class="!m-0">
                Feature ID: {{ feature?.id || feature?.feature_id }}
            </nz-tag>
        </div>
    </div>

    <!-- Base feature form (available for all features) -->
    <form nz-form [formGroup]="featureForm" (ngSubmit)="onSubmit()">
        <!-- Feature Status and Applications Section -->
        <div class="mb-6 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
            <nz-form-item class="items-start mb-0">
                <nz-form-label [nzSm]="6" [nzXs]="24" class="pt-1">
                    <span class="font-medium text-gray-700">Feature Status</span>
                </nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24">
                    <div class="flex flex-wrap items-center gap-4">
                        <div class="flex items-center gap-2">
                            <nz-switch formControlName="enabled" [nzCheckedChildren]="'Enabled'"
                                [nzUnCheckedChildren]="'Disabled'">
                            </nz-switch>
                            <span class="text-sm font-medium" [class.text-green-600]="featureForm.get('enabled')?.value"
                                [class.text-gray-500]="!featureForm.get('enabled')?.value">
                                {{ featureForm.get('enabled')?.value ? 'Enabled' : 'Disabled' }}
                            </span>
                        </div>

                        <!-- Divider removed - no longer needed -->

                        <!-- Application selector removed - using global application context -->

                        <!-- Application availability message removed - using global application context -->
                    </div>
                </nz-form-control>
            </nz-form-item>
        </div>


        <!-- Dynamic Fields Section -->
        <ng-container *ngIf="dynamicFieldsConfiguration.length > 0 || customFieldsFormArray.length > 0">
            <div class="mb-6 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
                <div class="flex items-center justify-between mb-4">
                    <h5 class="text-base font-semibold text-gray-800 flex items-center m-0">
                        <i nz-icon nzType="setting" nzTheme="outline" class="mr-2 text-green-600"></i>
                        Configuration Fields
                    </h5>
                    <button nz-button nzType="primary" nzSize="small" type="button" (click)="addCustomField()"
                        class="!h-8 !px-4">
                        <i nz-icon nzType="plus" class="mr-1"></i>
                        Add Custom Field
                    </button>
                </div>

                <nz-form-item>
                    <nz-form-control [nzSpan]="24">
                        <div class="space-y-3">
                            <!-- Predefined Fields from Feature Definition -->
                            <div formArrayName="dynamicFields" *ngIf="dynamicFieldsConfiguration.length > 0">
                                <div *ngFor="let field of dynamicFieldsConfiguration; let i = index"
                                    class="dynamic-field-item p-4 border border-blue-200 rounded-lg bg-blue-50 hover:border-blue-300 transition-colors">
                                    <nz-form-item class="mb-0">
                                        <nz-form-label [nzSpan]="24">
                                            <div class="flex items-center gap-2 mb-2">
                                                <span class="font-medium text-gray-800">{{ field.key }}</span>
                                                <nz-tag nzColor="blue" class="!m-0 !text-xs">From Feature
                                                    Definition</nz-tag>
                                                <span class="text-xs text-gray-500">({{ field.type }})</span>
                                                <span class="text-xs text-gray-400 italic">Optional</span>
                                            </div>
                                        </nz-form-label>
                                        <nz-form-control [nzSpan]="24">
                                            <!-- Regular field inputs (non-group) -->
                                            <div *ngIf="field.type !== 'group' && field.type !== 'select'">
                                                <input *ngIf="field.type !== 'boolean'" nz-input
                                                    [formControl]="$any(dynamicFieldsFormArray.at(i))"
                                                    [type]="field.type === 'number' ? 'number' : (field.type === 'date' ? 'date' : 'text')"
                                                    [placeholder]="'Enter value for ' + field.key + ' (default: ' + (field.defaultValue || 'empty') + ')'"
                                                    class="!h-10 !text-sm" />
                                                <nz-select *ngIf="field.type === 'boolean'"
                                                    [formControl]="$any(dynamicFieldsFormArray.at(i))" nzSize="default"
                                                    class="!h-10">
                                                    <nz-option [nzValue]="true" nzLabel="True"></nz-option>
                                                    <nz-option [nzValue]="false" nzLabel="False"></nz-option>
                                                </nz-select>
                                                <div class="text-xs text-gray-500 mt-1"
                                                    *ngIf="field.defaultValue || field.value">
                                                    <i nz-icon nzType="info-circle" class="mr-1"></i>
                                                    Default: {{ field.defaultValue || field.value }}
                                                    <span class="text-gray-400 ml-1">(will be used if left empty)</span>
                                                </div>
                                            </div>

                                            <!-- Select field (dropdown) -->
                                            <div *ngIf="field.type === 'select'">
                                                <nz-select [formControl]="$any(dynamicFieldsFormArray.at(i))"
                                                    nzSize="default" class="!h-10"
                                                    nzPlaceHolder="Select {{ field.key }}">
                                                    <nz-option *ngFor="let option of field.options" [nzValue]="option"
                                                        [nzLabel]="option">
                                                    </nz-option>
                                                </nz-select>
                                                <div class="text-xs text-gray-500 mt-1">
                                                    <i nz-icon nzType="info-circle" class="mr-1"></i>
                                                    Default: {{ field.defaultValue || 'Not set' }}
                                                    <span class="text-gray-400 ml-1">(will be used if left empty)</span>
                                                </div>
                                            </div>

                                            <!-- Grouped field (with sub-fields) -->
                                            <div *ngIf="field.type === 'group'">
                                                <div [formGroup]="$any(dynamicFieldsFormArray.at(i))">
                                                    <div
                                                        class="mt-2 pl-4 border-l-2 border-blue-300 bg-blue-50 rounded p-3">
                                                        <div class="text-xs font-medium text-gray-700 mb-2">
                                                            <i nz-icon nzType="unordered-list" class="mr-1"></i>
                                                            Sub-Fields
                                                        </div>

                                                        <div formArrayName="subFields" class="space-y-2">
                                                            <div *ngFor="let subField of field.subFields; let j = index"
                                                                class="p-2 bg-white rounded border border-blue-200">
                                                                <div class="grid grid-cols-12 gap-2 items-center">
                                                                    <!-- Sub-field Key (read-only) -->
                                                                    <div class="col-span-3">
                                                                        <span
                                                                            class="text-xs font-medium text-gray-700">{{
                                                                            subField.key }}</span>
                                                                        <span class="text-xs text-gray-500 ml-1">({{
                                                                            subField.type }})</span>
                                                                    </div>

                                                                    <!-- Sub-field Value Input -->
                                                                    <div class="col-span-9">
                                                                        <input *ngIf="subField.type !== 'boolean'"
                                                                            nz-input
                                                                            [formControl]="$any($any(dynamicFieldsFormArray.at(i)).get('subFields')).at(j)"
                                                                            [type]="subField.type === 'number' ? 'number' : (subField.type === 'date' ? 'date' : 'text')"
                                                                            [placeholder]="'Enter ' + subField.key + ' (default: ' + (subField.defaultValue || 'empty') + ')'"
                                                                            class="!h-8 !text-xs" />
                                                                        <nz-select *ngIf="subField.type === 'boolean'"
                                                                            [formControl]="$any($any(dynamicFieldsFormArray.at(i)).get('subFields')).at(j)"
                                                                            nzSize="small" class="!h-8">
                                                                            <nz-option [nzValue]="true"
                                                                                nzLabel="True"></nz-option>
                                                                            <nz-option [nzValue]="false"
                                                                                nzLabel="False"></nz-option>
                                                                        </nz-select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="text-xs text-gray-500 mt-2">
                                                            <i nz-icon nzType="info-circle" class="mr-1"></i>
                                                            Default values will be used if left empty
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </nz-form-control>
                                    </nz-form-item>
                                </div>
                            </div>

                            <!-- Custom Fields Added by User -->
                            <div formArrayName="customFields" *ngIf="customFieldsFormArray.length > 0">
                                <div *ngFor="let fieldGroup of customFieldsFormArray.controls; let i = index"
                                    [formGroupName]="i"
                                    class="dynamic-field-item p-4 border border-green-200 rounded-lg bg-green-50 hover:border-green-300 transition-colors">
                                    <div class="flex items-start gap-4">
                                        <div class="flex-1 space-y-3">
                                            <!-- Field Key -->
                                            <nz-form-item class="mb-0">
                                                <nz-form-label nzRequired class="!text-xs">Field Key</nz-form-label>
                                                <nz-form-control
                                                    [nzErrorTip]="customFieldsFormArray.at(i).get('key')?.hasError('duplicateKey') ? 'This key is already used' : 'Field key is required'">
                                                    <input nz-input formControlName="key"
                                                        placeholder="e.g., maxValue, threshold, myField"
                                                        class="!h-9 !text-sm" />
                                                </nz-form-control>
                                            </nz-form-item>

                                            <!-- Field Type and Value Row -->
                                            <div class="grid grid-cols-2 gap-3">
                                                <!-- Type Select -->
                                                <nz-form-item class="mb-0">
                                                    <nz-form-label nzRequired class="!text-xs">Type</nz-form-label>
                                                    <nz-form-control>
                                                        <nz-select formControlName="type" nzSize="default" class="!h-9">
                                                            <nz-option *ngFor="let type of fieldTypes"
                                                                [nzValue]="type.value"
                                                                [nzLabel]="type.label"></nz-option>
                                                        </nz-select>
                                                    </nz-form-control>
                                                </nz-form-item>

                                                <!-- Value Input -->
                                                <nz-form-item class="mb-0">
                                                    <nz-form-label nzRequired class="!text-xs">Value</nz-form-label>
                                                    <nz-form-control [nzErrorTip]="'Value is required'">
                                                        <input *ngIf="fieldGroup.get('type')?.value !== 'boolean'"
                                                            nz-input formControlName="value"
                                                            [type]="fieldGroup.get('type')?.value === 'number' ? 'number' : (fieldGroup.get('type')?.value === 'date' ? 'date' : 'text')"
                                                            [placeholder]="'Enter value'" class="!h-9 !text-sm" />
                                                        <nz-select *ngIf="fieldGroup.get('type')?.value === 'boolean'"
                                                            formControlName="value" nzSize="default" class="!h-9">
                                                            <nz-option [nzValue]="true" nzLabel="True"></nz-option>
                                                            <nz-option [nzValue]="false" nzLabel="False"></nz-option>
                                                        </nz-select>
                                                    </nz-form-control>
                                                </nz-form-item>
                                            </div>
                                        </div>

                                        <!-- Remove Button -->
                                        <button nz-button nzType="text" nzDanger nzSize="small" type="button"
                                            (click)="removeCustomField(i)" nz-tooltip nzTooltipTitle="Remove field"
                                            class="!mt-6 !h-9 !w-9 !p-0 flex items-center justify-center">
                                            <i nz-icon nzType="delete" nzTheme="outline"></i>
                                        </button>
                                    </div>
                                    <div class="mt-2">
                                        <nz-tag nzColor="green" class="!m-0 !text-xs">Custom Field</nz-tag>
                                    </div>
                                </div>
                            </div>

                            <!-- Empty State -->
                            <div *ngIf="dynamicFieldsConfiguration.length === 0 && customFieldsFormArray.length === 0"
                                class="text-center py-8 text-gray-400 text-sm border-2 border-dashed border-gray-300 rounded-lg bg-gray-50">
                                <i nz-icon nzType="plus-circle" nzTheme="outline" class="text-3xl mb-2 block"></i>
                                <p class="mb-1">No configuration fields available</p>
                                <p class="text-xs">Click "Add Custom Field" to create custom key-value pairs</p>
                            </div>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </ng-container>
    </form>


    <!-- Action Buttons -->
    <div class="flex justify-end gap-3 mt-8 pt-6 border-t border-gray-200">
        <button nz-button nzType="default" nzSize="large" (click)="onCancel()">
            <i nz-icon nzType="close" class="mr-1"></i>
            Cancel
        </button>
        <button nz-button nzType="primary" nzSize="large" [nzLoading]="isLoading" (click)="onSubmit()"
            [disabled]="!featureForm.valid">
            <i nz-icon nzType="save" class="mr-1"></i>
            Save Configuration
        </button>
    </div>
</nz-spin>